import React from 'react';
// import dateFns from 'date-fns';
import * as dateFns from 'date-fns';
import { Link } from 'react-router-dom';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import api from '../../config/axiosInstance';
import { setMessage } from '../../store/actions/general';

class AlertDialog extends React.Component {
  state = {
    open: false,
    expiresIn: null,
    offer: null,
    alredyRead: false,
  };

  componentDidMount() {
    this.verifyLastDays();
  }

  verifyLastDays = async () => {
    const token = localStorage.getItem('token');
    const read = JSON.parse(localStorage.getItem('read'));
    const response = await api.post('/payments/paypal/show-offers', {
      headers: { Authorization: `Bearer ${token}` },
    }).catch((err) => {
      setMessage(err);
    });
    if (response) {
      response.data.offers.filter((offer) => {
        this.setState({ offer: offer.expiresIn });
        return offer.expiresIn;
      });
    }
    const dateBegin = new Date();
    const dateEnd = this.convertDate(this.state.offer);
    if (!this.props.openAgreement && !this.props.openGestor && !read) {
      this.setState({
        expiresIn: dateFns.differenceInCalendarDays(dateEnd, dateBegin),
        // eslint-disable-next-line no-unneeded-ternary
        open: dateFns.differenceInCalendarDays(dateEnd, dateBegin) > 0 && dateFns.differenceInCalendarDays(dateEnd, dateBegin) <= 3 ? true : false,
      });
    }
  }

  convertDate = (dateTimeString) => {
    if (dateTimeString) {
      // eslint-disable-next-line no-unused-vars
      const [date, time] = dateTimeString.split(' ');
      const [dd, MM, yyyy] = date.split('/');
      return new Date(yyyy, (MM - 1), dd, 0, 0);
    }
  }


  handleChange = name => (event) => {
    this.setState({ [name]: event.target.checked });
  };

  handleClose = () => {
    const { alredyRead } = this.state;
    localStorage.setItem('read', JSON.parse(!alredyRead));
    this.setState({ open: false, alredyRead: true });
  }

  render() {
    return (
      <div>
        <Dialog
          open={this.state.open}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Seu plano de suporte está acabando</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description" color="#222">
              O plano de Suporte Premium da sua empresa termina em {this.state.expiresIn} dia(s)! Renove-o agora mesmo para continuar com suas vantagens
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button component={Link} to="/assinatura" onClick={this.handleClose} variant="contained" color="primary" autoFocus>
              Renovar
            </Button>
            <Button onClick={this.handleClose} color="primary" autoFocus>
              Fechar
            </Button>
          </DialogActions>
        </Dialog>

      </div>

    );
  }
}

export default AlertDialog;
